import * as React from "react"
import { Col, Container, Row } from "react-bootstrap";
import algoliasearch from 'algoliasearch/lite';
import { RefinementList, InstantSearch, Configure, connectInfiniteHits, connectStateResults, NumericMenu, connectRange, connectSearchBox, connectMenu, Pagination, } from 'react-instantsearch-dom';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import PropertyCard from "../components/PropertyCard/PropertyCard";
import FilterOption from "../components/FilterOption/FilterOption";
import PropertyCardOffer from "../components/PropertyCardOffer/PropertyCardOffer";
import PropertyCardBig from "../components/PropertyCardBig/PropertyCardBig";
import Bookcard from "../components/BookCard/BookCard";
import "../pages/SearchResult/SearchResult.scss"
import { useQuery, gql } from "@apollo/client";
import BrandLogo from "../images/logo.svg";
import NoResultPage from "../components/NoResultPage";
import classNames from "classnames";
import $ from "jquery"

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_API_KEY);
const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

const PropertyList = ({ hits, listView, hasMore, refineNext, globalModule, searchType, page }) => {
    React.useEffect(() => {
        if(page != 1) {
            setTimeout(() => {
                refineNext();
            }, 400);
        } 
    }, [page])
    return (
        <div className={classNames("property-list", { "p-0": hits.length == 0 })}>
            <Row>
                {/* {(searchType == "sales" && listView) && <Col className="d-lg-block d-none" xs={12}>
                    {hits.slice(0, 1).map(property => 
                    <PropertyCardOffer
                            key={property._id}
                            searchResults={true}
                            propertyList={{
                                propertyImg: property.images,
                                propertyTitle: property.intro,
                                propertyPrice: `£ ${property.price.toLocaleString()}`,
                                propertyInfo: property.title,
                                propertyRoom: property.bedroom,
                                propertyBathroom: property.bathroom,
                                propertyReception: property.bathroom,
                                propertyDesc: property.description,
                                offerTag: property.status?.toLowerCase() === "under offer",
                                propertyStatus: property.searchType === "sales",
                                offerText: "Open house",
                                callInfo:'00000000',
                                propertyLink: `/property-${property.searchType === "sales" ? "for-sale" : "to-rent"}/${property.slug}-${property.objectID}?open=true/`
                            }}
                        />                        
                    )}
                </Col>} */}
                {hits.map((property, k) => 
                    <React.Fragment key={property._id}>
                        {listView ? 
                            <Col xs={12}>
                                {property?.open_house ?
                                <PropertyCardOffer
                                    key={property._id}
                                    searchResults={true}
                                    propertyList={{
                                        propertyImg: property.images,
                                        propertyTitle: property.intro,
                                        propertyPrice: `£ ${property.price.toLocaleString()}`,
                                        propertyInfo: property.title,
                                        propertyRoom: property.bedroom,
                                        propertyBathroom: property.bathroom,
                                        propertyReception: property.reception,
                                        price_qualifier: property.price_qualifier,
                                        propertyDesc: property.description,
                                        offerTag: property.status?.toLowerCase() === "under offer",
                                        propertyStatus: property.searchType === "sales",
                                        offerText: "Open house",
                                        openHours:property?.open_house_dates,
                                        callInfo:'00000000',
                                        crm_id: property.crm_id,
                                        propertyLink: `/property-${property.searchType === "sales" ? "for-sale" : "to-rent"}/${property.slug}-${property.objectID}?open=true/`
                                    }}
                                />
                                :
                                <PropertyCardBig
                                    key={property._id}
                                    searchResults={true}
                                    propertyId={property.objectID}
                                    propertyList={{
                                        propertyImg: property.images,
                                        propertyTitle: property.intro,
                                        propertyPrice: `£ ${property.price.toLocaleString()}`,
                                        propertyInfo: property.title,
                                        propertyRoom: property.bedroom,
                                        propertyBathroom: property.bathroom,
                                        propertyReception: property.reception,
                                        propertyDesc: property.description,
                                        propertyNegotiator: property.negotiator_email,
                                        available_from: property.available_from,
                                        price_qualifier: property.price_qualifier,
                                        status: property.status,
                                        offerTag: (property.status?.toLowerCase() === "under offer" ? property.status : ""),
                                        propertyStatus: property.searchType === "sales",
                                        offerText: "Under Offer",
                                        crmId: property.crm_id,
                                        callInfo:'00000000',
                                        propertyLink: `/property-${property.searchType === "sales" ? "for-sale" : "to-rent"}/${property.slug}-${property.objectID}/`
                                    }}
                                /> 
                                }
                                
                                {(k % 3 === 0 && globalModule && globalModule.Book_A_Appointment) && 
                                    <div className="mb-5">
                                        <Bookcard
                                            bookcardTitle={globalModule?.Book_A_Appointment?.Book_Title}
                                            bookcardContent={globalModule?.Book_A_Appointment?.Description}
                                            bookcardBtn={globalModule?.Book_A_Appointment?.Cta_Label}
                                            bookcardLink={globalModule?.Book_A_Appointment?.Cta_Link}
                                        />
                                    </div>
                                }
                            </Col> :
                            <React.Fragment>
                                {(k % 9 === 0 && k != 0 && globalModule && globalModule.Book_A_Appointment) && 
                                    <Col xs={12} className="mb-5">
                                        <Bookcard
                                            bookcardTitle={globalModule?.Book_A_Appointment?.Book_Title}
                                            bookcardContent={globalModule?.Book_A_Appointment?.Description}
                                            bookcardBtn={globalModule?.Book_A_Appointment?.Cta_Label}
                                            bookcardLink={globalModule?.Book_A_Appointment?.Cta_Link}
                                        />
                                    </Col>
                                }
                                <Col md={6} xl={4} xs={12}>
                                    <PropertyCard
                                        key={property._id}
                                        propertyId={property.objectID}
                                        searchResults={true}
                                        propertyList={{ 
                                            propertyImg: property.images,
                                            propertyTitle: property.intro,
                                            propertyPrice: `£ ${property.price.toLocaleString()}`,
                                            propertyInfo: property.title,
                                            propertyRoom: property.bedroom,
                                            propertyBathroom: property.bathroom,
                                            propertyReception: property.bathroom,
                                            available_from: property.available_from,
                                            price_qualifier: property.price_qualifier,
                                            status: property.status,
                                            offerTag: (property.status?.toLowerCase() === "under offer" ? property.status : ""),
                                            propertyStatus: property.searchType === "sales",
                                            offerText: "Under Offer",
                                            callInfo:'00000000',
                                            propertyLink: `/property-${property.searchType === "sales" ? "for-sale" : "to-rent"}/${property.slug}-${property.objectID}/`
                                        }}
                                    />
                                </Col>
                            </React.Fragment>
                            }
                    </React.Fragment>
                )}
                {(hits.length > 0 && hasMore) && (
                    <Col xl="12" className="load-col" id="load-more">
                        <button onClick={refineNext} disabled={!hasMore} className="btn btn-outline">load more properties</button>
                    </Col>
                )}
            </Row>
        </div>
    )
} 

const CustomInfiniteHits = connectInfiniteHits(React.memo(PropertyList));

const LoadingIndicator = connectStateResults(
    ({ isSearchStalled }, props) =>
        isSearchStalled ? <div className="col-12 text-center mb-5 pb-5"><img src={BrandLogo}/> </div> : <NoResultPage {...props}/>
);

const SearchBox = ({ refine, value }) => {
    React.useEffect(() => {
        refine(value.replace(/ /g, "-").toLowerCase())
    }, [value])
    return (
        <div/>
    )
}

const BedRoomFilter = ({ refine, value }) => {
    React.useEffect(() => {
        refine({
            min: value
        })
    }, [value])
    return (
        <div/>
    )
}

const MinPriceFilter = ({ refine, value, currentRefinement }) => {
    React.useEffect(() => {
        refine({
            min: value[0],
            max: value[1]
        })
    }, [value])
    return (
        <div/>
    )
}

const PropertyType = ({ refine, value, currentRefinement }) => {
    React.useEffect(() => {
        refine(value)
    }, [value])
    return (
        <div/>
    )
}

const CustomBedRoom = connectRange(BedRoomFilter);
const CustomSearchBox = connectSearchBox(SearchBox);
const CustomMinPrice = connectRange(MinPriceFilter);
const CustomPropertyType = connectMenu(PropertyType);

const SearchTemplate = (props) => {
    const [sold, setIncludeSold] = React.useState(false);
    const [underOffer, setIncludeUnderOffer] = React.useState(false);
    const [searchString, setSearchString] = React.useState("");
    const [minPrice, setMinprice] = React.useState("");
    const [maxPrice, setMaxprice] = React.useState("");
    const [bedroom, setBedrooms] = React.useState("");
    const [propertyType, setPropertyType] = React.useState("");
    const [query, setQuery] = React.useState("");
    const [page, setPage] = React.useState(1);
    const [searchState, setSearchState] = React.useState({});
    const [listView, setListView] = React.useState(false);

    const handleSubmit = () => {
        let searchState = {
            range: {
                bedroom: {},
                price: {}
            },
            menu: {}
        }
        if(searchString != "") {
            searchState.query = searchString;
        }

        //console.log("bedroom", bedroom);

        if(parseInt(bedroom) > 0) {
            searchState.range.bedroom.min = bedroom;
        }
        if(minPrice != "") {
            searchState.range.price.min = minPrice;
        }
        if(maxPrice != "") {
            searchState.range.price.max = maxPrice;
        }
        if(propertyType != "") {
            searchState.menu.building = propertyType;
        }
        props.changeStateAndUrl(searchState)
        setSearchState(searchState)
    }

    const includeSold = (value) => {
        setIncludeSold(value)
    }

    const includeUnderOffer = (value) => {
        setIncludeUnderOffer(value)
    }

    const getRefinement = () => {
        if(props.searchType == "sales") {
            let sales = ["For Sale", "Under Offer"];
            if(sold) {
                sales = ["For Sale", "Sold", "Under Offer"];
            }
            return sales;
        } else {
            let rent = ["To Let", "Under Offer"];
            if(sold) {
                rent = ["To Let", "Let", "Under Offer"];
            } 
            return rent;
        }
    }

    React.useEffect(() => {
        //console.log("changes query", props)
        let resultState = {
            range: {
                bedroom: {},
                price: {}
            },
            menu: {}
        }
        if(props.query != "") {
            setSearchString(props.query);
            setQuery(props.query);
            resultState.query = props.query;
        } else {
            setQuery("");
            setSearchString("");
        }
        if(props.bedrooms != "") {
            setBedrooms(props.bedrooms);
            resultState.range.bedroom.min = props.bedrooms;
        }
        if(props.min != "") {
            setMinprice(props.min);
            resultState.range.price.min = props.min;
        }
        if(props.max != "") {
            setMaxprice(props.max);
            resultState.range.price.max = props.max;
        }
        if(props.building != "") {
            setPropertyType(props.building);
            resultState.menu.building = props.building;
        }
        setSearchState(resultState)
    }, [props.min, props.max, props.bedrooms, props.query, props.building]);

    const { data, loading, error } = useQuery(gql`
        query BannerQuery {
            globalModule {
                Book_A_Appointment {
                  Book_Title
                  Cta_Label
                  Description
                }
            }
        }
    `);

    React.useEffect(() => {
        if(window.innerWidth <= 1024) {
            setListView(false)
        }
    }, []);
    

    React.useEffect(() => {
        //console.log(props.page)
        if(props.page != 1) {
            setPage(props.page);
        }
    }, [props.page])

    var status_type = "";
    if(props.searchType == "sales") {
        status_type = ["For Sale", "Under Offer"];
        if(sold) {
            status_type = ["For Sale", "Sold", "Under Offer"];
        }
    } else {
        status_type = ["To Let", "Under Offer"];
        if(sold) {
            status_type = ["To Let", "Let", "Under Offer"];
        } 
    }

    let mystatus = ''
    if(status_type){
        if(Array.isArray(status_type)){
            mystatus = '(status:"'+(status_type).join('" OR status:"')+'")'
        } else {
            mystatus = '(status:"'+(status_type)+'")'
        }
    }
    
    return (
        <div>
            <Header menuLinks={[]}/>
            <InstantSearch
                indexName={index_name}
                searchClient={client}
                onSearchStateChange={async(state) => {
                    //console.log("state", state)
                    if(typeof state.page !== "undefined") {
                        //console.log("state", state)
                        if(state.page !== "" && state.page != 1) {
                            let searchStates = searchState;
                            searchStates["page"] = state.page;
                            await setSearchState(searchStates)
                            props.changeStateAndUrl(searchStates);
                        }
                    }
                }}
            >
                <FilterOption
                    {...props}
                    includeSold={includeSold}
                    includeUnderOffer={includeUnderOffer}
                    minPrice={minPrice}
                    maxPrice={maxPrice}
                    h1={props.h1}
                    bedroom={bedroom}
                    propertyType={propertyType}
                    query={query}
                    searchString={searchString}
                    listView={listView}
                    setSearchString={setSearchString}
                    setListView={(val) => setListView(val)}
                    setMinprice={setMinprice}
                    setMaxprice={setMaxprice}
                    setBedrooms={setBedrooms}
                    setPropertyType={setPropertyType}
                    handleSubmit={handleSubmit}
                    mapView={props.mapView}
                    index_name={index_name}
                    sales={props.searchType == "sales" ? true : false }
                    location={props.location}
                    search_area={props.search_area}
                />
                <div className="d-none">
                    {/* <RefinementList
                        attribute="searchType"
                        defaultRefinement={[props.searchType]}
                    />
                    <RefinementList
                        attribute="status"
                        defaultRefinement={getRefinement()}
                    />
                    <RefinementList
                        attribute="publish"
                        defaultRefinement={["true"]}
                    /> */}
                </div>          
                
                <div className="d-none d-lg-block">
                    <CustomSearchBox value={searchState?.query ? searchState.query : ""}/>
                    <CustomBedRoom attribute="bedroom" value={searchState?.range?.bedroom?.min}/>
                    <CustomMinPrice attribute="price" value={[searchState?.range?.price?.min, searchState?.range?.price?.max]}/>
                    <CustomPropertyType attribute="building" value={searchState?.menu?.building}/>
                    {/* <CustomMaxPrice attribute="price" value={searchState?.range?.price?.max}/> */}
                    <Configure
                        hitsPerPage={20}
                        filters={`publish:true AND searchType:${props.searchType} AND ${mystatus}`}
                    />
                </div> 
                <Container>
                    <CustomInfiniteHits 
                        {...props} 
                        listView={listView} 
                        globalModule={data?.globalModule}
                    />
                </Container>
                <LoadingIndicator/>
            </InstantSearch>
            <Footer
                popularSearchForResults={true}
                searchtype={props.searchType}
            />
        </div>
    )
}

export default React.memo(SearchTemplate);
